import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
  Avatar,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@material-ui/icons/IndeterminateCheckBoxOutlined";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Matrix from "./Matrix";
import AddCodingQuestion from "./AddCodingQuestion";
import Editor from "@monaco-editor/react";

function QuestionSection({
  classes,
  quillFormats,
  quillModules,
  personName,
  setQuillContentEnglishDescription,
  setQuillContentHindiDescription,
  quillContentEnglishDescription,
  quillContentHindiDescription,
  setQuillContentEnglishQuestion,
  setQuillContentHindiQuestion,
  quillContentEnglishQuestion,
  quillContentHindiQuestion,
  formDetails,
  setFormDetails,
}) {
  const languageMap = {
    C: "c",
    "C++": "cpp",
    "Java Script": "javascript",
    Python: "python",
    Java: "java",
  };

  const handleTemplateChange = (language, value) => {
    setFormDetails((prev) => ({
      ...prev,
      code_language: prev.code_language.map((item) =>
        item.language === language ? { ...item, template: value } : item,
      ),
    }));
  };

  return (
    <div>
      {personName.map((link, index) => (
        <div key={index} className={classes.mt1}>
          {/* <Typography className={classes.centeredTitle} variant="h6">
            {capitalizeFirstLetter(link)}
          </Typography> */}
          <div
            className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
          >
            <Typography
              className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
              variant="h6"
              display="inline"
            >
              *Enter Problem
            </Typography>

            <div
              className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
              >
                Enter Your Problem here
              </FormLabel>
              <ReactQuill
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.quilladdsinglequestion}`}
                value={
                  link === "Hindi"
                    ? quillContentHindiQuestion
                    : quillContentEnglishQuestion
                }
                onChange={
                  link === "Hindi"
                    ? setQuillContentHindiQuestion
                    : setQuillContentEnglishQuestion
                }
                modules={quillModules}
                formats={quillFormats}
              />
            </div>
          </div>

          <div
            className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
          >
            <Typography
              className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
              variant="h6"
              display="inline"
            >
              *Example
            </Typography>
            <div
              className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
              >
                Type Example here
              </FormLabel>
              <ReactQuill
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.quilladdsinglequestion}`}
                value={
                  link === "Hindi"
                    ? quillContentHindiDescription
                    : quillContentEnglishDescription
                }
                onChange={
                  link === "Hindi"
                    ? setQuillContentHindiDescription
                    : setQuillContentEnglishDescription
                }
                modules={quillModules}
                formats={quillFormats}
              />
            </div>
          </div>
          {formDetails?.code_language?.map((data, i) => (
            <div
              key={data.language}
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.mb1}`}
                variant="h6"
              >
                {i === 0 && "Default Templates"}
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w75}`}
              >
                <FormLabel className={`${classes.mb0_5}`}>
                  Template For {data.language}
                </FormLabel>

                <Editor
                  height="300px"
                  language={languageMap[data.language]}
                  theme="vs-dark"
                  value={data.template || ""}
                  onChange={(value) =>
                    handleTemplateChange(data.language, value)
                  }
                  options={{
                    fontSize: 14,
                    minimap: { enabled: false },
                    automaticLayout: true,
                    tabSize: 4,
                    formatOnType: true,
                    formatOnPaste: true,
                    padding: {
                      top: 16,
                      bottom: 16,
                    },
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default QuestionSection;
